<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item class="first" label="上架状态">
        <EnumSelect
          type="IntegralGoodsStatus"
          selector="select"
          v-model="searchCondition.status"
          clearable
          style="width:100px"
        ></EnumSelect>
      </Form-item>
      <Form-item label="商品类型">
        <EnumSelect
          type="IntegralGoodsType"
          selector="select"
          v-model="searchCondition.goods_type"
          clearable
          style="width:100px"
        ></EnumSelect>
      </Form-item>
      <Form-item label="名称">
        <Input
          style="width:200px"
          placeholder="请输入名称关键字"
          v-model="searchCondition.name"
          clearable
          @keydown.native.enter="search(1)"
        />
      </Form-item>
      <Form-item label="更新时间">
        <Date-picker
          :editable="false"
          ref="formDate"
          type="datetimerange"
          placeholder="开始时间 — 结束时间"
          style="width:280px;"
          @on-change="onDateRange"
          clearable
        ></Date-picker>
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button type="primary" @click="showCreateModal=true">新增商品</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/integral/index"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="id"
        method="post"
      >
        <template slot-scope="{ row }" slot="c1">
          <div class="cover-name">
            <div class="cover-wrap">
              <img v-if="!!row.cover_img" class="cover" :src="row.cover_img" />
            </div>
            <div>
              <div>{{row.name}}</div>
              <div class="integral">{{row.exchange_price}}积分</div>
            </div>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" @click="sortGoods(row)" :disabled="row.status==1">排序-</Button>
          <Button
            type="text"
            size="small"
            :to="{name: 'IntegralGoodsEdit',query:{id:row.id,type:row.goods_type}}"
          >编辑-</Button>
          <Button type="text" size="small" @click="deleteGoods(row.id)" :disabled="row.status==1">删除</Button>
        </template>
        <template slot="footer-left">
          <Button
            class="btn-margin-right"
            type="text"
            :disabled="selectList.length == 0"
            @click="batchDelete"
          >删除</Button>
        </template>
      </Grid>
    </div>
    <Modal v-model="showCreateModal" title="新增商品" footer-hide>
      <ul class="course-select">
        <li class="course-select-item" @click="createGoods(1)">
          <div class="course-select-title">课程</div>
          <div>可选择平台内已创建的课程作为积分商品，学员可使用积分直接兑换</div>
        </li>
        <li class="course-select-item" @click="createGoods(2)">
          <div class="course-select-title">图书</div>
          <div>可选择平台内已创建的图书作为积分商品，学员可使用积分直接兑换</div>
        </li>
      </ul>
    </Modal>
    <Modal class="modal-sort" v-model="showSortModal" title="排序" footer-hide>
      <span>移动至</span>
      <InputNumber :min="1" :precision="0" v-model="sort"></InputNumber>
      <span>位</span>
      <Button type="primary" @click="confirmSortGoods">保存</Button>
    </Modal>
  </div>
</template>
<script>
import { IntegralGoodsType, BookStatus, CourseStatus } from "@/utils/enums";
export default {
  name: "IntegralStore",
  data() {
    return {
      searchCondition: {
        status: "",
        goods_type: "",
        name: "",
        start_time: "",
        end_time: ""
      },
      selectList: [],
      showCreateModal: false,
      showSortModal: false,
      columns: [
        {
          title: "商品名称",
          key: "name",
          slot: "c1",
          minWidth: 200
        },
        {
          title: "商品类型",
          key: "goods_type_name",
          width: 120,
          align: "center"
        },
        {
          title: "已兑换",
          key: "sales_num",
          width: 100,
          align: "center"
        },
        {
          title: "剩余库存",
          key: "surplus",
          width: 100,
          align: "center"
        },
        {
          title: "上架状态",
          key: "status_name",
          width: 100,
          align: "center"
        },
        {
          title: "创建人",
          key: "nickname",
          width: 120,
          align: "center"
        },
        {
          title: "更新时间",
          key: "updated_at_str",
          width: 160,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          width: 240,
          align: "center",
          fixed: "right"
        }
      ],
      sortId: "",
      sort: 1
    };
  },
  methods: {
    onDateRange(range) {
      if (range[0]) {
        this.searchCondition.start_time = parseInt(
          new Date(range[0]).getTime() / 1000
        );
      } else {
        this.searchCondition.start_time = "";
      }
      if (range[1]) {
        this.searchCondition.end_time = parseInt(
          new Date(range[1]).getTime() / 1000
        );
      } else {
        this.searchCondition.end_time = "";
      }
    },
    search(flag) {
      if (flag == 0) {
        this.$refs.formDate.handleClear();
        this.searchCondition.status = "";
        this.searchCondition.name = "";
        this.searchCondition.goods_type = "";
        this.searchCondition.start_time = "";
        this.searchCondition.end_time = "";
      }
      if (this.searchCondition.status === undefined) {
        this.searchCondition.status = "";
      }
      if (this.searchCondition.goods_type === undefined) {
        this.searchCondition.goods_type = "";
      }
      this.$refs.grid.searchRefresh();
      this.selectList = [];
    },
    createGoods(type) {
      this.$router.push({ name: "IntegralGoodsEdit", query: { type: type } });
    },
    rowsFormatter(rows) {
      rows.forEach(row => {
        row.updated_at_str = this.$pub.timestampToTime(row.updated_at);
        row.goods_type_name = IntegralGoodsType.getValue(row.goods_type);
        if (row.goods_type == 1) {
          row.status_name = CourseStatus.getValue(row.course_status);
        } else {
          row.status_name = BookStatus.getValue(row.book_status);
        }
        row.surplus = row.stock - row.sales_num;
      });
    },
    onSelectionChange(list) {
      this.selectList = list;
    },
    async deleteGoods(id) {
      await this.$promiseConfirm("确定要删除吗？");
      await this.$http.delete("/api/integral/delete/" + id);
      this.$refs.grid.refresh();
    },
    async batchDelete() {
      let ids = [];
      for (let i = 0; i < this.selectList.length; i++) {
        let item = this.selectList[i];
        ids.push(item.id);
      }
      let id = ids.join(",");
      await this.deleteGoods(id);
      this.selectList = [];
    },
    sortGoods(item) {
      this.sortId = item.id;
      this.sort = item.sort;
      this.showSortModal = true;
    },
    async confirmSortGoods() {
      if (this.sort == "" || Number(this.sort) < 1) {
        this.$Message.info("请输入排序");
        return;
      }
      await this.$http.put("/api/integral/sort/" + this.sortId, {
        sort: this.sort
      });
      this.showSortModal = false;
      this.$refs.grid.refresh();
    }
  }
};
</script>
<style lang="scss" scoped>
.course-select {
  display: flex;
  justify-content: space-around;
}

.course-select-item {
  width: 176px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  height: 240px;
  color: #7f6697;
  margin: 8px;
  cursor: pointer;
  padding: 43px 28px;
  text-align: justify;
}

.course-select-title {
  color: black;
  font-size: 16px;
  text-align: center;
  position: relative;
  margin-bottom: 30px;
}

.course-select-type {
  position: absolute;
  color: red;
  font-size: 12px;
  top: -5px;
}

.cover-name {
  display: flex;
  align-items: center;
  .cover-wrap {
    width: 30px;
    height: 40px;
    margin-right: 15px;
  }
  .cover {
    width: 100%;
    height: 100%;
  }
  .integral {
    color: #f95959;
  }
}

.modal-sort {
  /deep/ {
    .ivu-modal-header {
      display: none;
    }
    .ivu-btn-primary {
      margin-left: 30px;
    }
  }
}
</style>